export default function Footer() {
  return (
    <footer className="bg-black border-t border-gray-900 py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold text-white mb-3">
              Miami Line Lux Detailing
            </h3>
            <p className="text-gray-400 mb-4">
              Premium mobile auto detailing serving Miami and surrounding areas. We bring showroom-level results to your driveway.
            </p>
            <div className="flex gap-3">
              <a
                href="sms:+17863272644"
                className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center text-yellow-500 hover:bg-yellow-500 hover:text-black transition-all cursor-pointer"
              >
                <i className="ri-message-3-line"></i>
              </a>
              <a
                href="https://wa.me/17863272644"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center text-yellow-500 hover:bg-yellow-500 hover:text-black transition-all cursor-pointer"
              >
                <i className="ri-whatsapp-line"></i>
              </a>
              <a
                href="tel:+17863272644"
                className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center text-yellow-500 hover:bg-yellow-500 hover:text-black transition-all cursor-pointer"
              >
                <i className="ri-phone-line"></i>
              </a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold mb-4">Contact</h4>
            <div className="space-y-3 text-gray-400">
              <a
                href="tel:+17863272644"
                className="flex items-center gap-2 hover:text-yellow-500 transition-colors cursor-pointer"
              >
                <i className="ri-phone-line"></i>
                (786) 327-2644
              </a>
              <div className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-1"></i>
                <span>Serving 30-mile radius around Miami, FL</span>
              </div>
              <div className="flex items-start gap-2">
                <i className="ri-time-line mt-1"></i>
                <span>Available 7 days a week</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold mb-4">Services</h4>
            <ul className="space-y-2 text-gray-400">
              <li className="flex items-center gap-2">
                <i className="ri-checkbox-circle-line text-yellow-500"></i>
                Interior Detailing
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-checkbox-circle-line text-yellow-500"></i>
                Exterior Detailing
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-checkbox-circle-line text-yellow-500"></i>
                Full Detail Packages
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-checkbox-circle-line text-yellow-500"></i>
                Paint Protection
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-900 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Miami Line Lux Detailing. All rights reserved.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 text-sm hover:text-yellow-500 transition-colors"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
